import type { SanctumAuthUserLike } from './SanctumAuthUserLike'

export function hasTwoFactorEnabled(user: SanctumAuthUserLike | null): boolean {
  return user !== null && user.two_factor_enabled
}
